// src/locales/enDict.js
import { frTranslations } from './frDict';

// Since our keys are the actual English text (to prevent any content loss),
// the English dictionary simply maps the text to itself.
export const enTranslations = Object.keys(frTranslations).reduce((acc, key) => {
  acc[key] = key;
  return acc;
}, {});
